import { useMutation, useQueryClient } from '@tanstack/react-query';

import { gitOpsWorkflowDetach } from '@api/sdk.gen';

import { withError } from '@/react-tools/react-query';

import { Workflow } from '../types';
import { workflowQueryKeys } from '../../queries/query-keys';

async function detachWorkflow(id: Workflow['id']): Promise<void> {
  await gitOpsWorkflowDetach({ path: { id } });
}

export function useDetachWorkflowMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: detachWorkflow,
    onSuccess: (_, id) => {
      queryClient.removeQueries({ queryKey: workflowQueryKeys.detail(id) });
      queryClient.invalidateQueries({ queryKey: workflowQueryKeys.all });
    },
    ...withError('Unable to detach workflow'),
  });
}
